export const calculateCartTotalWhatts = (items) => {
	const total =
		items &&
		items.length &&
		items.reduce((acc, item) => acc + calculateItemTotalWhatts(item), 0);

	return total || 0;
};

export const calculateItemTotalWhatts = (item) => {
	const { additionals } = item;

	const valorFinalProduct =
		additionals.length > 0 ? item.value : item.valueItem;

	const selectedAdditionalsGroupsTotal =
		(additionals &&
			additionals.length &&
			additionals.reduce(
				(acc, current) => Number(acc + current.valueItem),
				[]
			)) ||
		0;

	const total =
		item.quantity * (valorFinalProduct + selectedAdditionalsGroupsTotal);

	return total;
};

export const caculateProductsQuantity = (products) =>
	products
		? products.reduce((quantity, product) => quantity + product.quantity, 0)
		: 0;
